import { render, staticRenderFns } from "./VerificareApl.vue?vue&type=template&id=56315a82"
import script from "./VerificareApl.vue?vue&type=script&lang=js"
export * from "./VerificareApl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports